import { BooleanInput, SearchInput } from 'react-admin'

const PackageListFilters = [
    <SearchInput variant="outlined" placeholder="Search name" source="public_name" alwaysOn />,
    <BooleanInput source="active" label="Published" variant="outlined" defaultValue={true} />
]

export default PackageListFilters
